class BankCodeService {
  static format(code) {
    return String(code).replace(/\s/g, '').replace(/^0+/, '');
  }
}

module.exports = BankCodeService;
